import { defineStore } from "pinia";
import { computed, reactive } from "vue";

/**
 * Телефон в международном формате по ITU-T E.164: код страны входит в число цифр, "+" не считается.
 * Минимум - ограничение API лидов, максимум задаёт стандарт
 */
const PHONE_DIGITS_MIN = 9;
const PHONE_DIGITS_MAX = 15;

/** Необязательный "+" в начале, дальше цифры с пробелами, дефисами и скобками */
const PHONE_PATTERN = /^\+?[\d\s()-]+$/;

export interface CompanyContacts {
    companyName: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

function createContacts(): CompanyContacts {
    return { companyName: "", firstName: "", lastName: "", email: "", phone: "" };
}

export const useCompanyStore = defineStore("company", () => {
    const contacts = reactive<CompanyContacts>(createContacts());

    const phoneDigits = computed(() => contacts.phone.replace(/\D/g, ""));

    const isPhoneValid = computed(() => {
        const phone = contacts.phone.trim();
        if (!phone) return true;

        const digits = phoneDigits.value;
        return (
            PHONE_PATTERN.test(phone) &&
            !digits.startsWith("0") &&
            digits.length >= PHONE_DIGITS_MIN &&
            digits.length <= PHONE_DIGITS_MAX
        );
    });

    function trimContacts(): void {
        for (const key of Object.keys(contacts) as (keyof CompanyContacts)[]) {
            contacts[key] = contacts[key].trim();
        }
    }

    function reset(): void {
        Object.assign(contacts, createContacts());
    }

    return {
        contacts,

        phoneDigits,
        isPhoneValid,

        trimContacts,
        reset,
    };
});
